module.exports = __webpack_public_path__ + "static/media/SPB389_01.59a45c8f.png";